import { createReducer, on } from '@ngrx/store';
import { EnergyStarItem } from '../../model/energy-star-item.model';
import {
  loadEnergyStarItems,
  loadEnergyStarItemsSuccess,
  loadEnergyStarItemsError,
  clearEnergyStarItems,
  submitEnergyStarApplication,
  submitEnergyStarApplicationSuccess,
  submitEnergyStarApplicationError,
  clearEnergyStarSubmissionError,
  updateEnergyStarStatus,
  updateEnergyStarStatusSuccess,
  updateEnergyStarStatusError,
} from '../actions/energy-star-item.actions';

export default interface EnergyStarItemState {
  energyStarItems: EnergyStarItem[];
  loading: boolean;
  error: Error | null;
  submissionLoading: boolean;
  submissionError: string | null;
  statusUpdateLoading: boolean;
  statusUpdateError: string | null;
}

export const initialEnergyStarItemState: EnergyStarItemState = {
  energyStarItems: [],
  loading: false,
  error: null,
  submissionLoading: false,
  submissionError: null,
  statusUpdateLoading: false,
  statusUpdateError: null,
};

export const energyStarItemReducer = createReducer(
  initialEnergyStarItemState,
  on(
    loadEnergyStarItems,
    (state): EnergyStarItemState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    loadEnergyStarItemsSuccess,
    (state, { energyStarItems }): EnergyStarItemState => ({
      ...state,
      energyStarItems,
      loading: false,
      error: null,
    }),
  ),
  on(
    loadEnergyStarItemsError,
    (state, { error }): EnergyStarItemState => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(
    clearEnergyStarItems,
    (state): EnergyStarItemState => ({
      ...state,
      energyStarItems: [],
      loading: false,
      error: null,
    }),
  ),
  on(
    submitEnergyStarApplication,
    (state): EnergyStarItemState => ({
      ...state,
      submissionLoading: true,
      submissionError: null,
    }),
  ),
  on(
    submitEnergyStarApplicationSuccess,
    (state): EnergyStarItemState => ({
      ...state,
      submissionLoading: false,
      submissionError: null,
    }),
  ),
  on(
    submitEnergyStarApplicationError,
    (state, { error }): EnergyStarItemState => ({
      ...state,
      submissionLoading: false,
      submissionError: error,
    }),
  ),
  on(
    clearEnergyStarSubmissionError,
    (state): EnergyStarItemState => ({
      ...state,
      submissionError: null,
    }),
  ),
  on(
    updateEnergyStarStatus,
    (state): EnergyStarItemState => ({
      ...state,
      statusUpdateLoading: true,
      statusUpdateError: null,
    }),
  ),
  on(
    updateEnergyStarStatusSuccess,
    (state): EnergyStarItemState => ({
      ...state,
      statusUpdateLoading: false,
      statusUpdateError: null,
    }),
  ),
  on(
    updateEnergyStarStatusError,
    (state, { error }): EnergyStarItemState => ({
      ...state,
      statusUpdateLoading: false,
      statusUpdateError: error,
    }),
  ),
);
